import React, { useContext, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
  Grid,
  Typography,
  IconButton,
  useMediaQuery,
  Button as MuiButton,
} from "@material-ui/core";
import { CircleArrowBack, CircleArrowFowardIcon } from "../icons";
import { CheckButton, Button } from "./";
import { theme } from "../theme";
import { QuantityContext } from "../context";

const NOT_AVAIBLE_TO_REQUEST = [
  "661822077b4df03548c403f9",
  "661822297b4df03548c403fa",
];

export default function ProductCard(props) {
  const {
    product,
    onClickSelect,
    modal,
    productsList,
    onClickDelete,
    add1,
    delete1,
    onClickRequest,
    lab,
    req,
    hideQuantity,
    hideListQuantity,
    onClickLab,
    isSelect,
    viewList,
    popUp,
    labName,
  } = props;

  const isAssignBtnDisabled = () => {
    const statusToDisable = [
      "661822297b4df03548c403fa",
      "661822407b4df03548c403fb",
    ];

    return statusToDisable.includes(product.status?.toString());
  };

  const isPromo =
    product.name.toLowerCase().includes("pronto:") ||
    product.name.toLowerCase().includes("promo:") ||
    product?.isPromo;

  const quantity = useMemo(() => {
    return isPromo ? "" : product.assigned - product.used;
  }, [isPromo, product.assigned, product.used]);

  const [isChecked, setIsChecked] = useState(isSelect);
  const matches = useMediaQuery("(min-width:320px) and (max-width:375px)");
  const classes = useStyles({
    modal,
    quantity,
    req,
    viewList,
    lab,
    matches,
    isAssignBtnDisabled: isAssignBtnDisabled(),
    ...props,
  })();

  const history = useHistory();
  const { setQuantity } = useContext(QuantityContext);

  const updateIsChecked = () => {
    setIsChecked(!isChecked);

    onClickSelect();
  };

  const productDetails = () => {
    history.push("/sample", {
      product: product,
      productsList,
      isPromo,
      hideQuantity: isPromo || hideQuantity,
    });
    setQuantity({ quantity });
  };

  return (
    <>
      {!modal && (
        <>
          <Grid container justify="flex-end" className={classes.container}>
            {/* {quantity === 0 && !lab && viewList && (
              <div className={classes.requestButton}>
                <Button onClick={onClickRequest}>SOLICITAR</Button>
              </div>
            )} */}
            <Grid container className={classes.box}>
              <div className={classes.box_1}>
                {!isPromo && (
                  <CheckButton
                    disabled={(!req && quantity === 0) || isAssignBtnDisabled()}
                    isChecked={isChecked}
                    onClick={updateIsChecked}
                  />
                )}
              </div>
              <div className={classes.box_2}>
                <img src={product.logo} alt=" " />
              </div>
              <div className={classes.box_3}>
                {product.name.toLowerCase().includes("pronto:") ||
                product.name.toLowerCase().includes("promo:") ? (
                  <Typography style={{ fontSize: 16 }}>
                    <b>{product.name}</b>
                  </Typography>
                ) : (
                  <Typography>{product.name}</Typography>
                )}
                {/* <Typography>Exp. {new Date(product.validity).toLocaleDateString()}</Typography> */}
                <Typography className="text-blue">
                  {product.laboratory.name}
                </Typography>

                {!isPromo && !hideQuantity && !lab && (
                  <Typography>
                    {/* {console.log(
                      "Disponibilidad:",
                      product.status,
                      "Producto: ",
                      product.name
                    )} */}
                    {product.status === "661822297b4df03548c403fa" ? (
                      <strong>Sin muestras disponibles</strong>
                    ) : product.status === "661822077b4df03548c403f9" ? (
                      <strong>Temporalmente suspendido</strong>
                    ) : hideListQuantity ? null : (
                      <>
                        Disponibles: <strong>{quantity}</strong>
                      </>
                    )}
                  </Typography>
                )}

                {!lab && (
                  <Typography>
                    Estudios:{" "}
                    <strong>{product?.clinicalStudies?.length}</strong>
                  </Typography>
                )}
                {lab && (
                  <>
                    {/* <Typography className={classes.labName}>{labName}</Typography> */}
                    <Typography>{labName}</Typography>
                    <Button onClick={onClickLab}>CONTACTAR</Button>
                  </>
                )}
              </div>
              {quantity < 1 && product.status?.toString() !== "661822407b4df03548c403fb" && (
                <div className={classes.box_5}>
                  <Grid>
                    <MuiButton
                      style={{ borderRadius: 100, lineHeight: "1.3" }}
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={onClickRequest}
                    >
                      Solicitar muestra
                    </MuiButton>
                  </Grid>
                </div>
              )}
              <div className={classes.box_4}>
                {(!popUp || !isAssignBtnDisabled()) && (
                  <>
                    {/* {quantity < 1 && !NOT_AVAIBLE_TO_REQUEST.includes(product.status) && (
                      <Button
                        style={{ fontSize: "small", minWidth: "6rem" }}
                        onClick={onClickRequest}
                      >
                        SOLICITAR
                      </Button>
                    )} */}
                    <IconButton
                      disabled={isAssignBtnDisabled()}
                      className="details-button"
                      onClick={productDetails}
                    >
                      <CircleArrowFowardIcon />
                    </IconButton>
                  </>
                )}
              </div>
              {/* {!viewList && !lab && !hideQuantity && (
                <div className={classes.requestButton}>
                  <Typography>
                    Disponibles <strong>{quantity}</strong>
                  </Typography>
                  <Button onClick={onClickRequest}>SOLICITAR</Button>
                </div>
              )} */}
              {lab && !viewList && (
                <div className={classes.labButton}>
                  <Typography className={classes.labName}>{labName}</Typography>
                  <Button onClick={onClickLab}>CONTACTAR</Button>
                </div>
              )}
            </Grid>
          </Grid>
        </>
      )}
      {modal && (
        <Grid container className={classes.modalBox} justify="space-between">
          <div>
            {" "}
            <img src={product.logo} alt="" />
          </div>
          <div>
            <Typography>{product.name}</Typography>
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ margin: "15px 0 0 0" }}
            >
              <Grid item xs={6}>
                <Button onClick={() => onClickDelete()}>ELIMINAR</Button>
              </Grid>
              <Grid container className={classes.controlQuantity} item xs={6}>
                <CircleArrowBack
                  color={theme.palette.secondary.main}
                  onClick={() => delete1()}
                />
                <div>
                  <Typography>{product.quantityToAssign}</Typography>
                </div>
                <CircleArrowFowardIcon
                  color={theme.palette.secondary.main}
                  onClick={() => add1()}
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
      )}
    </>
  );
}

const useStyles = ({
  modal,
  quantity,
  req,
  viewList,
  lab,
  matches,
  isAssignBtnDisabled,
  ...props
}) =>
  makeStyles((theme) => ({
    container: {
      height: viewList ? "100%" : 180,
      position: "relative",
    },
    box: {
      background: "#FFFFFF",
      boxShadow: "0px 4px 10px rgba(198, 198, 198, 0.5)",
      borderRadius: 22,
      width: "100%",
      height: viewList ? "auto" : matches ? "100%" : 180,
      [theme.breakpoints.up("md")]: {
        height: viewList ? "auto" : matches ? "100%" : 180,
      },
      padding: 13,
      // opacity: req ? 1 : quantity === 0 ? 0.5 : 1,
      position: "relative",
    },
    box_1: {
      height: viewList ? "100%" : 70,
      width: viewList ? "10%" : "30%",
      display: "flex",
      justifyContent: viewList ? "center" : "flex-start",
      alignItems: "center",
      opacity: quantity < 1 || isAssignBtnDisabled ? "0.5" : "1",
      "& img": {
        objectFit: "contain",
        width: "100%",
        height: "100%",
      },
      "& button": {
        padding: viewList ? 12 : 0,
      },
    },
    box_2: {
      height: viewList ? "100%" : 70,
      width: viewList ? "20%" : "50%",
      display: "flex",
      opacity: quantity < 1 || isAssignBtnDisabled ? "0.5" : "1",
      "& p": {
        fontSize: "0.813rem",
        lineHeight: "1rem",
        color: theme.palette.primary.main,
        fontWeight: "500",
      },
      "& div": {
        height: "fit-content",
      },
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        margin: "0 0 10px 0",
        [theme.breakpoints.up("md")]: {
          width: viewList ? 60 : 80,
          height: viewList ? 60 : 80,
          maxHeight: "unset",
          maxWidth: "unset",
        },
      },
    },
    box_3: {
      width: viewList ? "30%" : "80%",
      order: viewList ? "initial" : "1",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "flex-start",
      flexDirection: "column",
      padding: viewList ? "0 0 0 20px" : 0,
      boxSizing: "border-box",
      opacity: quantity < 1 || isAssignBtnDisabled ? "0.5" : "1",
      "& p": {
        "-webkit-hyphens": "none",
        "-moz-hyphens": "none",
        overflowWrap: "break-word",
        //wordWrap: "break-word",
        hyphens: "auto",
        wordWrap: "normal",
        width: "100%",
        fontSize: "0.813rem",
        color: theme.palette.primary.main,
        fontWeight: "500",
        lineHeight: "1rem",
        padding: viewList ? "0 0 0 5px" : 0,
      },
      "& > .text-blue": {
        color: theme.palette.secondary.main,
        display: viewList ? "block" : "none",
      },
      "& > button": {
        fontSize: "0.688rem",
        lineHeight: "0.813rem",
        fontWeight: "bold",
        width: "fit-content",
        borderRadius: 12.5,
        height: 26,
        display: viewList ? "block" : "none",
      },
    },
    box_4: {
      // width: viewList ? "15%" : "25%",
      marginLeft: "auto",
      width: "10%",
      display: "flex",
      justifyContent: "center",
      alignItems: viewList ? "center" : "center",
      opacity: quantity < 1 || isAssignBtnDisabled ? "0.5" : "1",
      order: viewList ? "initial" : "2",
      "& img": {
        objectFit: "contain",
      },
      "& > details-button": {
        padding: viewList ? 12 : "unset",
      },
    },
    box_5: {
      position: "absolute",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1,
      backgroundColor: "#ffffff3b",
      top: 0,
      left: 0,
      "& div": {
        width: "max-content",
        maxWidth: viewList ? "300px" : "none",
      },
    },
    requestButton: {
      width: viewList ? "40%" : "100%",
      height: viewList ? "80%" : "unset",
      margin: viewList ? 0 : "10px 0 0 0",
      display: "flex",
      alignItems: viewList ? "flex-end" : "center",
      justifyContent: "space-between",
      position: viewList ? "absolute" : "relative",
      zIndex: 2,
      "& > button": {
        fontSize: "0.688rem",
        lineHeight: "0.813rem",
        width: 82,
        borderRadius: 12.5,
        height: 26,
        visibility:
          (quantity === 0 && !lab) || !isAssignBtnDisabled
            ? "visible"
            : "hidden",
      },
      "& p": {
        //color:theme.palette.secondary.main,
        fontSize: "0.813rem",
        color: theme.palette.primary.main,
        fontWeight: "500",
        lineHeight: "1rem",
      },
    },
    modalBox: {
      background: "#FFFFFF",
      boxShadow: "0px 4px 10px rgba(198, 198, 198, 0.5)",
      borderRadius: 22,
      width: "100%",
      height: 100,
      padding: 13,
      "& div:nth-child(1)": {
        width: "30%",
        height: "100%",
        "& img": {
          objectFit: "contain",
          width: "100%",
          height: "100%",
        },
      },
      "& > div:nth-child(2)": {
        width: "65%",
        "& p": {
          fontSize: "0.813rem",
          color: theme.palette.primary.main,
          fontWeight: "500",
          lineHeight: "1rem",
        },
        "& > div": {
          "& > div": {
            "& > button": {
              width: 80,
              height: 25,
              padding: "0 18px",
              borderRadius: 20.5,
              fontSize: "0.688rem",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          },
        },
      },
    },
    controlQuantity: {
      justifyContent: "space-around",
      alignItems: "center",
      "& div": {
        width: 41,
        height: 31,
        border: `2px solid ${theme.palette.secondary.main}`,
        boxSizing: "border-box",
        borderRadius: 25,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& p": {
          fontSize: "1rem",
          lineHeight: "1.25rem",
          fontWeight: "600",
          color: theme.palette.secondary.main,
        },
      },
    },
    labButton: {
      width: "100%",
      height: "fit-content",
      "& > p": {
        "-webkit-hyphens": "none",
        "-moz-hyphens": "none",
        overflowWrap: "break-word",
        //wordWrap: "break-word",
        hyphens: "auto",
        wordWrap: "normal",
        width: "100%",
        color: theme.palette.secondary.main,
        fontWeight: "500",
        margin: "0 0 6px 0",
      },
      "& button": {
        fontSize: "0.688rem",
        lineHeight: "0.813rem",
        fontWeight: "bold",
        width: "fit-content",
        borderRadius: 12.5,
        height: 26,
      },
    },
    labName: {
      // fontSize: ".406rem!important",
      // lineHeight: ".5rem!important",
    },
  }));
